import { WarehouseSnapshot } from '../../models/NV04';
import * as actionTypesNV04 from '../actions/actionTypesNV04';
import * as fromApp from '../rootReducer';

export interface FeatureState extends fromApp.AppState {
  state: NV04State;
}

export interface NV04State {
  snapshot: WarehouseSnapshot | null;
  error: any;
  isFetching: boolean;
}

const initialState: NV04State = {
  snapshot: null,
  error: undefined,
  isFetching: false,
};

const NV04Reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypesNV04.NV04_SNAPSHOT_GET:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };
    case actionTypesNV04.NV04_SNAPSHOT_SUCCESS:
      return {
        ...state,
        snapshot: action.payload,
        isFetching: false,
        error: undefined,
      };
    case actionTypesNV04.NV04_SNAPSHOT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case actionTypesNV04.NV04_CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default NV04Reducer;
